import { render, staticRenderFns } from "./SomeTalkOfOurClients.vue?vue&type=template&id=6bb53060&scoped=true&"
import script from "./SomeTalkOfOurClients.vue?vue&type=script&lang=js&"
export * from "./SomeTalkOfOurClients.vue?vue&type=script&lang=js&"
import style0 from "./SomeTalkOfOurClients.vue?vue&type=style&index=0&id=6bb53060&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb53060",
  null
  
)

export default component.exports